import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { loader } from "../../../loader";
import { connect } from "react-redux";
import {
  getEmailData,
  getSearched, getSelected,
  getSelectedSmartListData,
} from "../../../actions";
import { toast } from "react-toastify";
import { popup_alert } from "../../../popup_alert";
import { useNavigate } from "react-router-dom";
import { ENDPOINT } from "../../../axios/apiConfig";
import { postData } from "../../../axios/apiHelper";
var old_object = {};
var trainingUser = {};
var searchedUser = {};
var new_object;
var draft_object;

const SelectVwdUser = (props) => {
  const rdLikeArray = ["56Ek4feL/1A8mZgIKQWEqg==", "bWmUjqX7J011   WUTYn9g==", "MXl8m36VZFYXpgFVz3Pg0g=="]
  const isLikeRdAccount = rdLikeArray.includes("FOkB/AUT2wGXRv ablqvbg==")
  const routeTypeSurvey = props?.type === 'survey' ? 1 : props?.type === 'vwd' ? 2 : 0;
  const surveyid = old_object?.survey_id ? old_object?.survey_id : props?.getDraftData?.campaign_data?.survey_id ? props?.getDraftData?.campaign_data?.survey_id : 0;
  const surveySubLinkId = old_object?.sublink_id ? old_object?.sublink_id : props?.getDraftData?.campaign_data?.sublink_id ? props?.getDraftData?.campaign_data?.sublink_id : 0;
  const priority = old_object?.priority ? old_object?.priority : props?.getDraftData?.campaign_data?.priority ? props?.getDraftData?.campaign_data?.priority : 0;
  const navigate = useNavigate();
  let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;

  const [selection, setSelection] = useState(0);
  const [isContentMandatory, setIsContentMandatory] = useState(0);
  const [title, setTitle] = useState('');
  const [templateId, setTemplateId] = useState(
    old_object?.selected
      ? old_object.selected
      : props.getDraftData?.campaign_data?.list_selection
        ? props.getDraftData.campaign_data.list_selection
        : 0
  );

  axios.defaults.baseURL = process.env.REACT_APP_API_KEY;
  const campaign_id = old_object
    ? old_object.campaign_id
    : props.getDraftData
      ? props.getDraftData.campaign_id
      : 0;

  const [campaign_id_st, setCampaign_id] = useState(campaign_id);

  const handleInputChange = (event, selectede) => {
  console.log("chnages here")

    if (old_object?.selected != selectede) {
      if (old_object?.removedHcp) {
        old_object.removedHcp = [];
      }
      if (old_object?.addedHcp) {
        old_object.addedHcp = [];
      }
      if (old_object?.selectedHcp) {
        old_object.selectedHcp = [];
      }
       if (old_object?.readerHcp) {
        old_object.readerHcp = [];
      }
      if (old_object?.readersNewlyAdded) {
        old_object.readersNewlyAdded = [];
      }

      if (old_object?.allusers) {
        old_object.allusers = [];
      }

      if (draft_object?.campaign_data?.removedHcp) {
        draft_object.campaign_data.removedHcp = [];
      }
      if (draft_object?.campaign_data?.readersNewlyAdded) {
        draft_object.campaign_data.readersNewlyAdded = [];
      }

      if (draft_object?.campaign_data?.allusers) {
        draft_object.campaign_data.allusers = [];
      }

      if (draft_object?.campaign_data?.addedHcp) {
        draft_object.campaign_data.addedHcp = [];
      }
      if (draft_object?.campaign_data?.selectedHcp) {
        draft_object.campaign_data.selectedHcp = [];
      }
       if (draft_object?.campaign_data?.readerHcp) {
        draft_object.campaign_data.readerHcp = [];
      }
      props.getSelected(null);
      props.getSearched(null);
    } else {
      props.getSelected(trainingUser);
      props.getSearched(searchedUser);
    }

    if (old_object) {
      old_object.selected = selectede;
      props.getEmailData(old_object);
    } else {
      props.getEmailData({ selected: selectede });
    }

    setSelection(event.target.children[0].value);

    const div = document.querySelector("div.active");

    if (div) {
      div.classList.remove("active");
    }
    event.target.classList.toggle("active");

    setTemplateId(selectede);
    nextClicked(selectede);
  };

  const backClicked = () => {
    props.getEmailData(old_object);
    props.getSelected(trainingUser);
    props.getSearched(searchedUser);

    let pdfSelectedId = props.getEmailData
      ? props.getEmailData.pdf_id
      : props.getDraftData.pdf_id;
    
    const backRoute = "/vwd/CreateEmail";
    navigate(backRoute, {
      state: { PdfSelected: pdfSelectedId },
    });
  };


  const saveAsDraft = async () => {
    const body = {
      user_id: "FOkB/AUT2wGXRv ablqvbg==",
      pdf_id: old_object?.PdfSelected
        ? old_object.PdfSelected
        : props.getDraftData.pdf_id,
      description: old_object?.emailDescription
        ? old_object.emailDescription
        : props.getDraftData?.description
          ? props.getDraftData.description
          : "",
      creator: old_object?.emailCreator
        ? old_object.emailCreator
        : props.getDraftData?.creator
          ? props.getDraftData.creator
          : "",
      campaign_name: old_object?.emailCampaign
        ? old_object.emailCampaign
        : props.getDraftData.campaign,
      subject: old_object?.emailSubject
        ? old_object.emailSubject
        : props.getDraftData.subject,
      route_location: routeTypeSurvey === 1 ? "survey/email/select-hcp" : routeTypeSurvey === 2 ? "SelectVwdUser" : "SelectHCP",
      tags: old_object?.tags ? old_object.tags : props.getDraftData.tags,
      campaign_data: {
        template_id: old_object?.templateId
          ? old_object.templateId
          : props.getDraftData.campaign_data.template_id,
        list_selection: templateId,
        sublink_id: old_object?.sublink_id
          ? old_object.sublink_id
          : surveySubLinkId,
        survey_id: old_object?.survey_id
          ? old_object.survey_id
          : surveyid,
        priority :priority
      },
      campaign_id: campaign_id_st,
      source_code: old_object?.template
        ? old_object.template
        : props.getDraftData.source_code,
      status: 2,
    };

    axios.defaults.baseURL = process.env.REACT_APP_API_KEY;
    loader("show");
    await axios
      .post(`emailapi/save_draft`, body)
      .then((res) => {
        loader("hide");
        if (res.data.status_code === 200) {
        const redirectRoute = routeTypeSurvey === 1 ? "/survey/email" : routeTypeSurvey === 2 ? "/vwd/email" : "/EmailList";
         setCampaign_id(res.data.response.data.id);
          popup_alert({
            visible: "show",
            message: "Your changes has been saved <br />successfully !",
            type: "success",
            redirect: redirectRoute,
          });
        } else {
          toast.warning(res.data.message);
        }
      })
      .catch((err) => {

        toast.error("Something went wrong");
      });
  };

  const getVwdUserDetails = (type) => {
    const ibtValue = type === 1 ? 0 : 1;
    // navigate to same route with ibt value
    navigate("/VwdUsers", {
      state: {
        ibt: ibtValue,
      },
    });
  };

const nextClicked = async (selected) => {
 // props.getEmailData(old_object);
  // const ibtValue = type === 1 ? 0 : 1;
 // setIbtValue(ibtValue);
//   if (selected === 1 || selected === 2) {
//     getVwdUserDetails(selected);
//   }
};

  useEffect(() => {
    if (isLikeRdAccount) {
      checkMandatoryContent();
    }
  }, []);

  const checkMandatoryContent = async () => {
    try {
      axios.defaults.baseURL = process.env.REACT_APP_API_KEY;
      const body = {
        user_id: "FOkB/AUT2wGXRv ablqvbg==",
        pdf_id: old_object?.PdfSelected
          ? old_object.PdfSelected
          : props.getDraftData.pdf_id,
      };
      loader("show");
      await axios.post(`emailapi/check_mandatory_content`, body)
        .then((res) => {
          setTitle(res?.data?.response?.data?.title);
          setIsContentMandatory(res?.data?.response?.data?.mandatory_content);
          loader("hide");
        }).catch((err) => {
          console.log(err);
          loader("hide");
        });
    } catch (err) {
      console.log(err, 'er');
    }
  }
const nextClickedNew = async (selected) => {
  console.log(old_object,"nextClickedNew")
  props.getEmailData(old_object);
  const ibtValue = templateId === 1 ? 0 : 1;
  navigate("/VwdUsers", {
    state: {
      ibt: ibtValue,
    },
  });
}

  return (
    <>
      <div className="col right-sidebar">
        <div className="custom-container">
          <div className="row">
            <div className="page-top-nav">
              <div className="row justify-content-end align-items-center">
                <div className="col-12 col-md-1">
                  <div className="header-btn-left">
                    <button
                      className="btn btn-primary btn-bordered back"
                      onClick={backClicked}
                    >
                      Back
                    </button>
                  </div>
                </div>
                <div className="col-12 col-md-8">
                  <ul className="tabnav-link">
                    <li className="active">
                      {
                        <Link to="/vwd/EmailArticleSelect">Select Content</Link>
                      }
                    </li>
                    <li className="active">
                      {
                        <Link to="/vwd/CreateEmail">Create Your Email</Link>
                      }
                    </li>
                    <li className="active active-main">
                      <a href="#">Select Users</a>
                    </li>
                    <li className="">
                      <a href="#">Verify your list</a>
                    </li>
                    <li className="">
                      <a href="#">Verify your Email</a>
                    </li>
                  </ul>
                </div>
                <div className="col-12 col-md-3">
                  <div className="header-btn">
                    {
                      (isLikeRdAccount)
                        ?
                        <Link to={"/vwd/email"}
                          className="btn btn-primary btn-bordered move-draft engine_cancel">
                          Cancel
                        </Link>
                        : null
                    }
                    <button
                      className="btn btn-primary btn-bordered"
                      onClick={saveAsDraft}
                    >
                      Save As Draft
                    </button>
                    {templateId === 0 ? (
                      <button className="btn btn-primary btn-filled next disabled">
                        Next{" "}
                      </button>
                    ) : (

                      <button
                        className="btn btn-primary btn-filled next"
                        onClick={(event) => nextClickedNew(templateId)}
                      >
                        Next
                      </button>

                    )}
                  </div>
                </div>
              </div>
            </div>
            <section className="send-mail-options">
              <div className="container">
                <div className="row">
                  <div className="send-option-list">
                    <h5>Do you want to send to</h5>
                    <ul>
                      <li>
                        <div
                          className={
                            templateId === 1
                              ? "send-option-img active"
                              : "send-option-img"
                          }
                          onClick={(event) => handleInputChange(event, 1)}
                        >
                          <input
                            type="radio"
                            name="select-option-hcp"
                            value="group of HCPs"


                          />

                          <img
                            src={path_image + "group-hcp.svg"}
                            alt="Group HCPs"
                          />
                        </div>

                        <p>
                          {isLikeRdAccount
                            ? "Group of Users"
                            : "All Users"}{" "}
                        </p>
                      </li>
                      <li>
                        <div
                          className={
                            templateId === 2
                              ? "send-option-img active"
                              : "send-option-img"
                          }
                          onClick={(e) => handleInputChange(e, 2)}
                        >
                          <input
                            type="radio"
                            name="select-option-hcp"
                            value="Single HCP"
                          />
                          <img
                            src={path_image + "single-hcp.svg"}
                            alt="Single HCP"
                          />
                        </div>
                        <p>
                          {isLikeRdAccount
                            ? "Single User"
                            : "IBT Users"}{" "}
                        </p>
                      </li>


                    </ul>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  old_object = state.getEmailData;
  new_object = state.getSelectedSmartListData;
  draft_object = state.getDraftData ? state.getDraftData : {};
  trainingUser = state?.getSelected;
  searchedUser = state?.getSearched;
  return state;
};

export default connect(mapStateToProps, {
  getEmailData,
  getSelected,
  getSearched,
  getSelectedSmartListData,
})(SelectVwdUser);
